import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import categoryAPI from "../../../../services/category";
import {
  triggerDynamicAlert,
  categoryDetailsAlert,
} from "../../../../components/alert/sweetAlert";
import HeaderNavBar from "../../../header/nav";
import DynamicBreadcrumb from "../../../header/breadcrumb";

import "./category.css";

function Category() {
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const columns = [
    { field: "id", headerName: "S.No", width: 70 },
    {
      field: "categoryImage",
      headerName: "Category Image",
      width: 300,
      renderCell: (params) => (
        <img
          src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${params.value}`}
          alt={params.value}
          style={{ maxWidth: "100%" }}
        />
      ),
    },
    { field: "categoryDetails", headerName: "Category Details", width: 170 },
    {
      field: "bannerImages",
      headerName: "Banner Images",
      width: 300,
      renderCell: (params) => (
        <img
          src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${params.value}`}
          alt={params.value}
          style={{ maxWidth: "100%" }}
        />
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => (
        <Row>
          <Col
            key={params.id + "-status"}
            className={"ms-2 p-2 me-2 d-grid gap-2"}
          >
            <button
              onClick={handleClick}
              className={`btn ${
                params.value === 1 ? "btn-danger" : "btn-secondary"
              } custom-status-button`}
              style={{ outline: "none", boxShadow: "none" }}
            >
              {params.value === 1 ? "Active" : "Inactive"}
            </button>
          </Col>
        </Row>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 250,
      renderCell: (params) => (
        <Row>
          <Col key={params.id + "-view"} className={"ms-2 px-2 me-2"}>
            <button
              className="btn btn-outline-warning"
              onClick={() => handleShowDetails(params.row)}
            >
              <FontAwesomeIcon icon="fa-solid fa-eye" size="sm" />
            </button>
          </Col>
          <Col key={params.id + "-edit"} className={"ms-2 px-2 me-2"}>
            <button className="btn btn-outline-info">
              <FontAwesomeIcon icon="fa-solid fa-edit" size="sm" />
            </button>
          </Col>
          <Col key={params.id + "-delete"} className={"ms-2 px-2 me-2"}>
            <button className="btn btn-outline-primary" onClick={handleDelete}>
              <FontAwesomeIcon icon="fa-solid fa-trash" size="sm" />
            </button>
          </Col>
        </Row>
      ),
    },
  ];

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const data = await categoryAPI.getAllCategory(pageSize, page);
        // console.log(data?.data);
        const formattedData = data?.data.map((category, index) => ({
          ...category,
          id: index + 1, // Unique id for the DataGrid
          categoryImage: category.image,
          categoryDetails: category.categoryName,
          bannerImages: category.bannerImage,
        }));
        setRows(formattedData);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [page, pageSize]);

  const handleClick = () => {
    triggerDynamicAlert("Are you sure to change status?", "", "warning");
  };

  const handleDelete = () => {
    triggerDynamicAlert(
      "Are you sure?",
      "Products under this category will be deleted!",
      "warning",
      "Yes, delete it!"
    );
  };

  const handleShowDetails = (data) => {
    categoryDetailsAlert("", data);
  };

  const handleAddCategory = () => {
    navigate("/admin/category/add");
  };
  const pathArray = [
    {
      name: "Categories List",
      url: null,
    },
  ];
  return (
    <div>
      {/* Navbar */}
      <Container className="mt-4 mb-4">
        <DynamicBreadcrumb pathArray={pathArray} />
        <Col className="d-flex justify-content-between align-items-center my-3">
          <Col md={9}>
            <h4>Category Management</h4>
          </Col>
          <Col md={3}>
            <Button variant="danger" onClick={handleAddCategory}>
              Add Category
            </Button>
          </Col>
        </Col>
        <Box sx={{ height: 500, width: 1 }}>
          <DataGrid
            className="mt-1"
            rows={rows}
            columns={columns}
            pageSize={pageSize}
            rowsPerPageOptions={[5, 10, 20]}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            pagination
            loading={loading}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Box>
      </Container>
    </div>
  );
}

export default Category;
